<template>
    <div class="vrm-header__container" :class="headerClass">
        <slot v-if="!panelsUnderHeader" name="header-panels" />
        <div v-if="panelsUnderHeader" class="hidden-lg">
            <slot name="header-panels" />
        </div>
        <div class="container">
            <div class="row">
                <div class="col-xs-12">
                    <slot name="back-link" />
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row" :class="headerRowClass">
                <div
                    :class="{
                        'col-sm-8': hasControls || hasTitleControls,
                        'col-sm-12': !hasControls && !hasTitleControls,
                        'visible-lg-block': hasMobileTitle,
                    }"
                >
                    <slot name="page-title" />
                </div>
                <div class="col-xs-12 col-sm-8 hidden-lg">
                    <slot name="mobile-page-title" />
                </div>
                <div v-if="hasTitleControls" class="col-sm-4">
                    <slot name="title-controls" />
                </div>
                <div v-if="hasControls" class="vrm-header__controls visible-lg-block">
                    <slot name="header-controls" />
                </div>
            </div>
        </div>
        <div v-if="panelsUnderHeader" class="hidden-xxs hidden-xs hidden-sm hidden-md visible-lg">
            <slot name="header-panels" />
        </div>
    </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component()
export default class VrmHeader extends Vue {
    @Prop({ type: String, default: '' })
    headerClass;

    @Prop({ type: Boolean, default: false })
    panelsUnderHeader;

    @Prop({ type: String, default: '' })
    headerRowClass;

    get hasControls() {
        return this.$slots['header-controls'];
    }
    get hasMobileTitle() {
        return this.$slots['mobile-page-title'];
    }
    get hasTitleControls() {
        return this.$slots['title-controls'];
    }
}
</script>
